import { useEffect, useState } from 'react';
import Header from './header';
import Liste from './liste';
import Carte from './carte';
import { registerData } from './services/data-service';
import FiltersPanel from './filters-pannel/filtersPanel';
import { subscribeAppState } from './services/appstate-service';
import './App.scss';
import useTags from './hooks/use-tags';

function App({ src }) {

  const [isCompatible, setIsCompatible] = useState(true);
  const [data, setData] = useState(null);
  const [filtersOn, setFiltersOn] = useState(false);
  const { tags } = useTags();
  
  useEffect(() => {

    if(window.fetch && src){

      fetch(src).then(async response => {
        if(response.ok){
          const json = await response.json();
          registerData(json);
          setData(json);
        }
      });

    } else {
      
      setIsCompatible(false);

    }
    
  }, [src]);
  
  useEffect(() => {
    
    const unsubscribeAppState = subscribeAppState(onAppState);
    return function cleanup() {
      unsubscribeAppState(onAppState);
    }
  }, []);

  const onAppState = (newState) => {
    setFiltersOn(newState.filtersOpen);
  }

  if(!data) return <div className="loading">Chargement des données…</div>;

  return (
    <div className="data-map-app" style={{"--primary": data.params.colors.primary, "--secondary": data.params.colors.secondary}}>
      {isCompatible ? 
        data ?
          <>
            <Header defaultType={data.params.default} />
            <Liste tags={tags} />
            <Carte params={data.params} />
            { filtersOn ? <FiltersPanel /> : null }
          </> :
          <p>Chargement…</p>
      : <p>Cette application est incompatible avec votre navigateur. Veuillez utiliser un navigateur plus moderne.</p>}
    </div>
  );
}

export default App;
